module.exports = __webpack_public_path__ + "static/media/ProcesoEjecPenalH.534ddf9d.jpeg";